import { render, staticRenderFns } from "./GbLink.vue?vue&type=template&id=134bc9de"
import script from "./GbLink.vue?vue&type=script&lang=js"
export * from "./GbLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports